import { Button, PasswordInput, Text, TextInput} from "@tblabs/truffle";
import { LoginFormLogic } from "../Services/Auth/LoginFormLogic";
import { InfoBox } from "../Components/InfoBox";
import { Page } from "./Page";


export class LoginPage extends Page
{
    constructor(private _formLogic: LoginFormLogic)
    {
        super("Logowanie", "admin-page");

        this.body.Style(`margin-top: 64px; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 8px;`)
    }

    protected async OnAppend(): Promise<void>
    {
        if (this._formLogic.IsAuthorized)
        {
            this.body.Append(
                new InfoBox("Jesteś już zalogowany", `Jako ${this._formLogic.User.Name}`),
                new Button("Wyloguj").WidthAuto().OnClick(() => this._formLogic.Logout())
            );
            return;
        }

        const loginInput = new TextInput(this._formLogic.LoginInput).Color("#444").WidthAuto().BorderRadius(4)
            .Placeholder("Login")
            .OnEnterKeyPressed(async () => await this._formLogic.TryLogin())

        const passwordInput = new PasswordInput(this._formLogic.PasswordInput).Color("#444").StyleInput(`border-radius: 4px;`)
            .TogglePasswordView()
            .Placeholder("Hasło")
            .OnEnterKeyPressed(async () => await this._formLogic.TryLogin())

        const loginButton = new Button("Zaloguj").WidthAuto().Padding(8, 24).FontNormal().BorderRadius(4).FontSize(16)
            .Disable(this._formLogic.LoginInProgress)
            .OnClick(async () => await this._formLogic.TryLogin())

        this.body.Append(
            loginInput,
            passwordInput,
            loginButton,
            new InfoBox("Błąd", new Text(this._formLogic.ErrorMessage))
                .Visible(this._formLogic.ErrorMessageVisible),
        );
    }
}